import React, { createContext, useContext } from 'react';

const Context = createContext();

export const DurationAndTimeProvider = ({ config, children }) => {
  return <Context.Provider value={config}>{children}</Context.Provider>;
};

export const useDurationAndTimeConfig = () => useContext(Context);
